import { PositionType } from 'data/types';

export type FootprintRotationDegrees = 90 | 180 | 270;

export function footprintCentroid(points: PositionType[]): PositionType {
  return {
    x: points.reduce((sum, point) => sum + point.x, 0) / points.length,
    y: points.reduce((sum, point) => sum + point.y, 0) / points.length
  };
}

export function footprintBboxCenter(points: PositionType[]): PositionType {
  const xs = points.map((point) => point.x);
  const ys = points.map((point) => point.y);
  return {
    x: (Math.min(...xs) + Math.max(...xs)) / 2,
    y: (Math.min(...ys) + Math.max(...ys)) / 2
  };
}

export function rotateFootprintPoints(
  points: PositionType[],
  degrees: FootprintRotationDegrees,
  pivot: PositionType
): PositionType[] {
  return points.map((point) => {
    const dx = point.x - pivot.x;
    const dy = point.y - pivot.y;
    let rotated = { x: dy, y: -dx };
    if (degrees === 90) {
      rotated = { x: -dy, y: dx };
    } else if (degrees === 180) {
      rotated = { x: -dx, y: -dy };
    }
    return {
      x: Math.round(pivot.x + rotated.x),
      y: Math.round(pivot.y + rotated.y)
    };
  });
}

export function rotateFootprintPointsAboutCentroid(
  points: PositionType[],
  degrees: FootprintRotationDegrees
): PositionType[] {
  return rotateFootprintPoints(points, degrees, footprintCentroid(points));
}
